<flo-video-player-by-code
  *ngIf="embedHash$ | async as embedHash"
  [embedHash]="[embedHash]"
  channel="video-embed"
></flo-video-player-by-code>
